// =============================================================
// 📦 Custom Cart Drawer Logic – Shopify Native + Custom Logic
// =============================================================

// 🧭 Open cart drawer
function openCartDrawer() {
  document.querySelector(".cart-drawer")?.classList.add("cart-drawer--active");
}

// ❌ Close cart drawer
function closeCartDrawer() {
  document.querySelector(".cart-drawer")?.classList.remove("cart-drawer--active");
}

// 🔢 Update cart count bubble in header
function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count-bubble span[aria-hidden]").forEach((el) => {
    el.textContent = count;
  });
}

// 🔁 Refresh cart drawer content and re-apply listeners
async function updateCartDrawer() {
  let sectionUrl = "/?section_id=cart-drawer";
  const languagePath = window.Shopify?.routes?.root || ''; 

  if (languagePath && languagePath !== '/') {
    sectionUrl = `${languagePath}${sectionUrl}`;
  }

  try {
    const res = await fetch(sectionUrl);
    if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;

    const newDrawerContent = html.querySelector(".cart-drawer")?.innerHTML;
    if (newDrawerContent) {
      document.querySelector(".cart-drawer").innerHTML = newDrawerContent;
      addCartDrawerListeners(); // 🔄 Rebind all drawer listeners
    } else {
        console.warn("Could not find or update .cart-drawer content.");
    }
    
  } catch (error) {
    console.error("Cart update failed, falling back to English content if loaded:", error);
    try {
        const res = await fetch("/?section_id=cart-drawer");
        const text = await res.text();
        const html = document.createElement("div");
        html.innerHTML = text;
        const newDrawerContent = html.querySelector(".cart-drawer")?.innerHTML;
        if (newDrawerContent) {
            document.querySelector(".cart-drawer").innerHTML = newDrawerContent;
            addCartDrawerListeners();
        }
    } catch(fallbackError) {
        console.error("Fallback to default language failed as well:", fallbackError);
    }
  }
}

// 🧠 Setup drawer interactivity
function addCartDrawerListeners() {
  // ➕➖ Quantity buttons with stock limit
  document.querySelectorAll(".cart-drawer-quantity-selector button").forEach((button) => {
    button.addEventListener("click", async () => {
      const rootItem = button.closest(".cart-drawer-item");
      const key = rootItem?.getAttribute("data-line-item-key");

      const input = button.parentElement.querySelector("input");
      const currentQuantity = Number(input.value);
      const max = Number(input.dataset.max) || Infinity;
      const isUp = button.classList.contains("cart-drawer-quantity-selector-plus");
      const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

      if (newQuantity < 1) return;
if (newQuantity > max) {
  const errorEl = rootItem.querySelector(".cart-drawer-error");
  if (errorEl) {
    const unavailableStockText = window.theme?.variantStrings?.unavailableStock || "Not enough stock available."; 
    errorEl.textContent = unavailableStockText; 
    
    // ⏳ Clear after 2 seconds
    setTimeout(() => {
      errorEl.textContent = "";
    }, 2000);
  }
  return;
}


      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: newQuantity } }),
      });

      const cart = await res.json();
      updateCartItemCounts(cart.item_count);
      await updateCartDrawer();
    });
  });

// 🗑️ Remove item
document.querySelectorAll(".cart-drawer-remove-link").forEach((button) => {
  button.onclick = async () => {
    const rootItem = button.closest(".cart-drawer-item");
    const key = rootItem?.getAttribute("data-line-item-key");
    if (!key) return;

    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [key]: 0 } }),
    });

    const cart = await res.json();
    updateCartItemCounts(cart.item_count);
    await updateCartDrawer();
  };
});


  // ❌ Close when clicking outside or on close button
  document.querySelectorAll(".cart-drawer-header-right-close, .cart-drawer").forEach((el) => {
    el.addEventListener("click", () => {
      closeCartDrawer();
    });
  });

  // ⛔ Prevent closing drawer when clicking inside content box
  document.querySelector(".cart-drawer-box")?.addEventListener("click", (e) => {
    e.stopPropagation();
  });

  // 🛍️ Replace default /cart behavior to open drawer
document.querySelectorAll('.header__icon--cart').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});
}

// 🛒 Intercept Add to Cart forms (delegated – works for dynamically added forms like in modals)
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[action$="/cart/add"]');
  if (!form) return;

  // Block Shopify's handler inside Quick Add modal
  const isInQuickAdd = form.closest('quick-add-modal') || form.closest('[id^="QuickAddInfo-"]');
  if (isInQuickAdd) e.stopImmediatePropagation();

  e.preventDefault();

  const submitButton = form.querySelector('[type="submit"]');
  const spinner = submitButton?.querySelector('.loading__spinner');
  const labelEl =
    submitButton?.querySelector('span[data-default-text]') ||
    submitButton?.querySelector('span');
  const originalLabel =
    labelEl?.getAttribute('data-default-text') ||
    labelEl?.textContent ||
    'Add to cart';

  // Start loading UI
  if (submitButton) {
    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.disabled = true;
    spinner?.classList.remove('hidden');
  }

  // Add to cart
  await fetch('/cart/add', { method: 'POST', body: new FormData(form) });

  // Update header bubble
  const cart = await (await fetch('/cart.js')).json();
  updateCartItemCounts(cart.item_count);

  // Stop loading UI and show ADDED briefly
  if (submitButton) {
    submitButton.removeAttribute('aria-disabled');
    submitButton.disabled = false;
    spinner?.classList.add('hidden');
    const addedLabel = labelEl?.dataset.addedText || '{{ "products.product.added_to_cart" | t }}';
if (labelEl) labelEl.textContent = addedLabel;
  }

  // Open drawer only after the modal closes
  let drawerPreload = null;
  const modal = form.closest('quick-add-modal');

  if (modal && typeof modal.hide === 'function') {
    // Give ADDED a moment, then close the modal
    drawerPreload = updateCartDrawer();
    setTimeout(() => modal.hide(true), 325);

    // Open drawer once the modal is closed
const onClosed = async () => {
  document.body.removeEventListener('modalClosed', onClosed);
  await drawerPreload;
  openCartDrawer();
};

    document.body.addEventListener('modalClosed', onClosed, { once: true });

    // Fallback in case no event is fired
setTimeout(async () => {
  try { document.body.removeEventListener('modalClosed', onClosed); } catch (_) {}
  await drawerPreload;
  openCartDrawer();
}, 900);
  } else {
    // No modal context
  await updateCartDrawer();
  openCartDrawer();
  }

  // Restore label later
  setTimeout(() => { if (labelEl) labelEl.textContent = originalLabel; }, 2000);
}, true);


// ✅ Initialize all listeners on load
addCartDrawerListeners();
